import React, { useState } from 'react';
import { faqs } from '../data/offer';
import { Disclosure } from './Disclosure';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-titulo" className="w-full bg-cream-100" data-id="element-54" data-mp="1blai55q0olsb">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-20 lg:py-28" data-id="element-55" data-mp="1gjltxlzvh6d6">
        <div className="grid gap-5 sm:gap-10 lg:grid-cols-[0.55fr_1.45fr] lg:gap-16" data-id="element-56" data-mp="1glgdowzeqsfo">
          <h2 id="faq-titulo" className="font-display text-2xl font-extrabold leading-tight tracking-tight text-forest-900 sm:text-4xl" data-id="element-57" data-mp="24baq5dfteeze">
            Preguntas frecuentes
          </h2>

          <div data-id="element-58" data-mp="1zihm6rs67aod">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <Disclosure key={faq.question} id={`faq-panel-${index}`} isOpen={isOpen} onToggle={() => setOpenIndex(isOpen ? null : index)} className="border-t border-cream-300 last:border-b" header={<span className="font-display text-[15px] font-bold leading-snug text-forest-900 sm:text-xl" data-id="element-60" data-mp="10v04agp7dyle">
                      {faq.question}
                    </span>} data-id="element-59" data-mp="2n7sbnd42lin7" data-mpi={index}>
                  <div className="max-w-2xl space-y-2 pr-6 text-sm leading-relaxed text-forest-800/85 sm:space-y-3 sm:pr-10 sm:text-[15px]" data-id="element-61" data-mp="19su1dtuskw9m">
                    {faq.answer.map(paragraph => <p key={paragraph} data-id="element-62" data-mp="1jjokipcqrfqu">{paragraph}</p>)}
                  </div>
                </Disclosure>;
          })}
          </div>
        </div>
      </div>
    </section>;
}